import * as React from 'react';
import { useDispatch } from 'redux-react-hook';
import { setSearchQuery } from '../../actions';

export interface SearchBarProps {}

export const SearchBar: React.FC<SearchBarProps> = () => {
  const dispatch = useDispatch();
  return (
    <div className="searchBar">
      <input
        type="text"
        placeholder="Store name/number/tel"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          dispatch(setSearchQuery(e.target.value))
        }
      />
    </div>
  );
};
